import { render, staticRenderFns } from "./MultipleRooms.vue?vue&type=template&id=203498d1&scoped=true"
import script from "./MultipleRooms.vue?vue&type=script&lang=js"
export * from "./MultipleRooms.vue?vue&type=script&lang=js"
import style0 from "./MultipleRooms.vue?vue&type=style&index=0&id=203498d1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "203498d1",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Button: require('/vercel/path0/components/common/Button.vue').default,CancellationButton: require('/vercel/path0/components/partials/CancellationButton.vue').default,Currency: require('/vercel/path0/components/partials/Currency.vue').default,RoomGallery: require('/vercel/path0/components/partials/RoomGallery.vue').default,Info: require('/vercel/path0/components/common/Info.vue').default,ModalScreen: require('/vercel/path0/components/common/ModalScreen.vue').default})
